import React from 'react'


function Navbar() {
  return (
    <nav className="navbar">
      <div className="logo">Gabriel Samson</div>
      <ul className="nav-list">
      <li className="nav-item"> <a href='#home'> Home</a></li>
        <li className="nav-item"><a href='#project'>Projects</a></li>
        <li className="nav-item"><a href='#skills'>Skills</a></li>
        <li className="nav-item"><a href='#experience'>Experience </a></li>
      </ul>
    </nav>
  )
}

export default Navbar
